<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M10.8 2.39999c-.2228.00012-.4412.06226-.6306.17947-.1895.1172-.34261.28484-.44219.48413l-.8688 1.7364h-4.0584c-.31826 0-.62349.12643-.84853.35148-.22505.22504-.35147.53026-.35147.84852 0 .31826.12642.62349.35147.84853.22504.22505.53027.35147.84853.35147V19.2c0 .6365.25285 1.247.70294 1.6971.45009.45 1.06054.7029 1.69706.7029H16.8c.6365 0 1.247-.2529 1.6971-.7029.45-.4501.7029-1.0606.7029-1.6971V7.19999c.3183 0 .6235-.12642.8485-.35147.2251-.22504.3515-.53027.3515-.84853s-.1264-.62348-.3515-.84852c-.225-.22505-.5302-.35148-.8485-.35148h-4.0584l-.8688-1.7364c-.0996-.19929-.2527-.36693-.4422-.48413-.1894-.11721-.4078-.17935-.6306-.17947h-2.4Zm-2.39999 7.2c0-.31826.12642-.62348.35147-.84852.22504-.22505.53027-.35148.84853-.35148s.62349.12643.84849.35148c.2251.22504.3515.53026.3515.84852V16.8c0 .3183-.1264.6235-.3515.8485-.225.2251-.53023.3515-.84849.3515s-.62349-.1264-.84853-.3515c-.22505-.225-.35147-.5302-.35147-.8485V9.59999Zm5.99999-1.2c-.3183 0-.6235.12643-.8485.35148-.2251.22504-.3515.53026-.3515.84852V16.8c0 .3183.1264.6235.3515.8485.225.2251.5302.3515.8485.3515s.6235-.1264.8485-.3515c.2251-.225.3515-.5302.3515-.8485V9.59999c0-.31826-.1264-.62348-.3515-.84852-.225-.22505-.5302-.35148-.8485-.35148Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="M8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2h4c.5304 0 1.0391.21071 1.4142.58579C15.7893 2.96086 16 3.46957 16 4v2h4c.5523 0 1 .44772 1 1s-.4477 1-1 1h-.0689l-.8006 11.213c0 .0001 0-.0001 0 0-.054.7568-.3926 1.4653-.9479 1.9824-.5552.5171-1.2858.8046-2.0446.8046H7.86202c-.75879 0-1.4894-.2875-2.04467-.8046-.55522-.5171-.89388-1.2254-.94781-1.9822-.00001 0 .00001.0001 0 0L4.06886 8H4c-.55228 0-1-.44772-1-1s.44772-1 1-1h4V4c0-.53043.21071-1.03914.58579-1.41421ZM10 6h4V4h-4v2ZM6.07395 8l.79051 11.0708c.01796.2523.13087.4886.31596.661.18509.1724.42863.2682.68158.2682h8.276c.253 0 .4965-.0958.6816-.2682s.298-.4085.3159-.6608L17.926 8H6.07395ZM10 10c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1-.55228 0-1-.4477-1-1v-6c0-.5523.44772-1 1-1Zm4 0c.5523 0 1 .4477 1 1v6c0 .5523-.4477 1-1 1s-1-.4477-1-1v-6c0-.5523.4477-1 1-1Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
